/* import __COLOCATED_TEMPLATE__ from './categories-with-featured-topics.hbs'; */
import Component from "@ember/component";

export default class CategoriesWithFeaturedTopics extends Component {}
